
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.96 0H4.94A4.946 4.946 0 000 4.94v8.02a4.945 4.945 0 004.94 4.94h8.02a4.946 4.946 0 004.94-4.94V4.94A4.946 4.946 0 0012.96 0zm3.353 12.96a3.356 3.356 0 01-3.352 3.352H4.94a3.355 3.355 0 01-3.352-3.351V4.94A3.355 3.355 0 014.94 1.588h8.02a3.356 3.356 0 013.352 3.352v8.02z"}}),_c('path',{attrs:{"d":"M8.95 4.338a4.618 4.618 0 00-4.612 4.613 4.618 4.618 0 004.612 4.612 4.618 4.618 0 004.613-4.612A4.618 4.618 0 008.95 4.338zm0 7.637A3.028 3.028 0 015.926 8.95 3.028 3.028 0 018.95 5.926a3.028 3.028 0 013.025 3.024 3.028 3.028 0 01-3.025 3.025zm4.806-8.984a1.17 1.17 0 00-1.164 1.165c0 .306.125.607.342.824.216.216.516.34.822.34.307 0 .607-.124.824-.34a1.17 1.17 0 000-1.648 1.17 1.17 0 00-.824-.34z"}})])
          )
        }
      }
    